/* eslint-disable react-hooks/exhaustive-deps */
import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DeleteButton from 'components/DeleteButton';
import {
  Radio,
  Col,
  Spin,
  Row,
  Divider,
  Select,
  notification,
  message,
  Input,
  Card,
  Popconfirm,
  InputNumber,
  Button,
} from 'antd';
import NewButtonSmall from 'components/NewButtonSmall';
import { CalculatorTwoTone } from '@ant-design/icons';
import moment from 'moment';
import * as finEngine from 'services/finEngine';
import DF from 'DisplayFramework';
import { getRounding, toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import {
  getFinContractById,
  getFinModificationByModid,
  getFinModificationValidByCtrid,
} from 'services/fincontract';
import SliderWithInput from 'components/SliderWithInput';
import Form, { FormInstance } from 'antd/lib/form';
import { dateToString, shouldUpdateCompare, unGroup } from 'utils/utils2';
import _, { debounce, groupBy, isEmpty } from 'lodash';
import { conElementToElement } from 'pages/ProposalV3/PropDetail/conElementToElement';
import ElementsFinTable from 'pages/ProposalV3/PropDetail/ElementsFinTable';
import {
  PropElementRequest,
  PropElementResponse,
  PropElemStepRequest,
  PropElemStepResponse,
} from 'services/proposal';
import Title from 'components/Title';
import Value from 'components/Value';
import InputRate from 'components/InputRate';
import SliderWithInputAndPercentage from 'components/SliderWithInputAndPercentage';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import InputCurrency from 'components/InputCurrency';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import InputMoney from 'components/InputMoney';
import { PricingResponse } from 'services/pricing';
import TextArea from 'antd/lib/input/TextArea';

const { Option } = Select;

export type tabCTReschedulingProps = {
  objectid: number;
  form?: FormInstance;
  setSuccessful?: any;
};

const TabCTRescheduling = ({
  objectid,
  form,
  setSuccessful,
}: tabCTReschedulingProps) => {
  const [state, setState] = useState({
    isLoading: false,
    effectDate: '',
    isModSelected: false,
    oldData: [],
  });
  const [elementID, setElementID] = useState(1);

  const updateState = useCallback(
    (values) => {
      setState((prev) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const { data, isLoading } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    { refetchOnMount: true }
  );

  const { data: modList, isFetching } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'RESCHEDUL',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  useEffect(() => {
    setSuccessful(isLoading && isFetching);
  }, [isLoading, isFetching]);

  const optionDates = form
    ?.getFieldValue(['elements', 'FIN'])
    ?.find((el: any) => el.cteid === form?.getFieldValue('selectedElement'))
    ?.conElemSchedules?.map(
      (e: any, index: any) =>
        e.ctstype !== 'UPFRONT' && (
          <Option key={index} value={e.ctsduedate.toString()}>
            {e.ctsduedate}
          </Option>
        )
    );
  const optionsMode = [
    { label: 'Simulation', value: 'SIMUL' },
    { label: 'Real', value: 'REAL' },
  ];
  const optionModListValid = modList?.map((e, index) => (
    <option key={index} value={e.modid}>
      {e.modcomment}
    </option>
  ));

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      updateState({ isModSelected: false });
      return;
    }

    updateState({ isLoading: true });

    let query = getFinModificationByModid({ modid: finmod });

    query.then((response) => {
      if (response.code !== '200') {
        return;
      }

      const res = response.data;
      form?.setFieldsValue({
        mode: 'REAL',
        effectDate: res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue,
        feesFormulaList: {
          priid: Number(
            res.simulParams.filter(
              (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
            )[0].newvalue
          ),
          prilabel: 'Fees Modification',
        },
        feesFormula: res.simulParams.filter(
          (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
        )[0].newvalue,
        feesAmount: res.simulParams.filter(
          (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
        )[0].newvalue,
      });

      debouncedCalculateNew(
        res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue
      );

      updateState({ isModSelected: true });

      updateState({ isLoading: false });
    });
  };

  const handleeffectDatechange = (date: any) => {
    debouncedCalculateNew(date);
  };
  const getName = (param: string, cteid: any) => {
    let lcteid = form?.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form?.getFieldValue(['elements', 'FIN'])) {
        const index = form
          ?.getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const rowStep = (ctesorder: number): PropElemStepResponse => {
    return {
      ctesamortizedcoef: 0,
      ctesid: Math.floor(_.random(10000) * 10000000),
      ctesorder: ctesorder,
      ctesyear:0,
      ctesyearend:0,
      ctesperiodicity: '1',
      ctesperiodicityunit: 'M',
      ctesduration: 1,
      ctesoutstandingamount: 0,
      ctesrentalamount: 0,
      ctesrentalcoef: 0,
      cteid: 0,
      ctesperiodicityunitlabel: '',
      ctrid: 0,
      status: 'ERROR',
    };
  };

  const calculateStepFinancial = useCallback(
    (index: number, method: string) => {
      const eleID = isNaN(form?.getFieldValue('selectedElement'))
        ? elementID
        : form?.getFieldValue('selectedElement');

      const indexElement = form
        ?.getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === eleID);

      const FinElements = form?.getFieldValue(['elements', 'FIN']);

      const finElement = FinElements[indexElement === -1 ? 0 : indexElement];

      const FinElemStep = form?.getFieldValue([
        'elements',
        'FIN',
        indexElement === -1 ? 0 : indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];

      const step = FinElemStep[index];

      // calculate FIN

      var finamount = 0;
      // const investamount = finElement.cteinvestamount;
      // const firstPayment = finElement.ctefirstpayment;
      // const rvAmount = finElement.ctervamount;
      // const upfront = finElement.cteupfrontamount;

      // var part = 0;

      const partmethod = finElement.ctepartmethod;

      if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
        // part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
      }
      // finamount = investamount - upfront - part;
      finamount = finElement.ctefinancedamount;
      var startamount = 0;

      if (index === 0) {
        startamount = finamount;
      } else {
        startamount = FinElemStep[index - 1].ctesoutstandingamount;
      }
      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method === 'INST' ? 'INST' : 'OUTSTAND',
            inCalculationType:finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: step.ctesduration,

            inFinancedAmount: startamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount: step.ctesrentalamount,
            inInterestMethod:
              index === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: step.ctesperiodicity,
            inPeriodicityUnit: step.ctesperiodicityunit,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue: step.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);

            const ctesrentalamount = res.installmentamount;
            const ctesrentalcoef =
              (res.installmentamount / finElement.cteinvestamount) * 100;
            const ctesoutstandingamount = res.residualvalue;
            const ctesamortizedcoef =
              (res.residualvalue / finElement.cteinvestamount) * 100;
            const status = 'OK';

            const newValues = FinElemStep.map((item, i) => {
              if (i !== index) {
                return item;
              }
              const updatedItem = { ...item };

              return {
                ...updatedItem,
                ctesrentalcoef,
                ctesrentalamount,
                ctesamortizedcoef,
                ctesoutstandingamount,
                status,
              };
            });

            // call FinEngine with new values :
            setAssetRvAmount(_.last(newValues)?.ctesoutstandingamount); //back
            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSteps: [...newValues],
                        conElemSchedules: res.paymentSchedule,
                      }
                    : element
                ),
              },
            });
          } else {
            message.error(res.message);
          }
        });

      /// end calculate FIN
      calculatePaymentSheduleStep(form?.getFieldValue('selectedElement'));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );

  const addStep = () => {
    const eleID = isNaN(form?.getFieldValue('selectedElement'))
      ? elementID
      : form?.getFieldValue('selectedElement');

    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === eleID);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]);

    if (FinElemStep === undefined || isEmpty(FinElemStep)) {
      FinElemStep = [rowStep(1)];
    } else {
      const ctesorder = FinElemStep?.length + 1;
      FinElemStep.push(rowStep(ctesorder));
    }
    form?.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
              }
            : element
        ),
      },
    });
  };

  const removeStep = (ctesid: number) => {
    const eleID = isNaN(form?.getFieldValue('selectedElement'))
      ? elementID
      : form?.getFieldValue('selectedElement');

    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === eleID);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as PropElemStepResponse[];

    FinElemStep = FinElemStep.filter((item) => item.ctesid !== ctesid);

    form?.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
                conElemSchedules: [],
              }
            : element
        ),
      },
    });
    debouncedCalculateNew(' ');
  };

  const addWeightedStep = () => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]);

    if (FinElemStep === undefined || isEmpty(FinElemStep)) {
      FinElemStep = [rowStep(1)];
    } else {
      const ctesorder = FinElemStep?.length + 1;
      FinElemStep.push(rowStep(ctesorder));
    }
    form?.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
              }
            : element
        ),
      },
    });
  };
  const recalculateWeightedSteps = useCallback(
    (index: number, field: string, updatedValues: any) => {
      const indexElement = form
        ?.getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === elementID);

      const FinElements = form?.getFieldValue(['elements', 'FIN']);

      const finAmount =
        form?.getFieldValue(getName('cteinstallmentamount', elementID)) !== 0 &&
        !isNaN(form?.getFieldValue(getName('cteinstallmentamount', elementID)))
          ? form?.getFieldValue(getName('cteinstallmentamount', elementID))
          : form?.getFieldValue([
              'elements',
              'FIN',
              indexElement,
              'cteinvestamount',
            ]) ?? 1;

      var FinElemStep = form?.getFieldValue([
        'elements',
        'FIN',
        indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];

      // eslint-disable-next-line array-callback-return
      const newValues = FinElemStep.map((item, i) => {
        if (i !== index) {
          return item;
        }

        const ctesrentalcoef =
          field === 'ctesrentalcoef' ? updatedValues : item.ctesrentalcoef;
        const ctesrentalamount =
          field === 'ctesrentalamount' ? updatedValues : item.ctesrentalamount;
        // const updatedItem = { ...item, ...{ field: updatedValues } };  => we cant assign field as string as object field
        const updatedItem = {
          ...item,
          ctesrentalcoef: ctesrentalcoef,
          ctesrentalamount: ctesrentalamount,
        };

        if (field === 'ctesorder') {
          const ctesorder = updatedValues;

          return {
            ...updatedItem,
            ctesorder,
            status: 'ERROR',
          };
        }
        if (field === 'ctesduration') {
          const ctesduration = updatedValues;

          return {
            ...updatedItem,
            ctesduration,
            status: 'ERROR',
          };
        }
        if (field === 'ctesperiodicity') {
          const ctesperiodicity = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicity,
            status: 'ERROR',
          };
        }

        if (field === 'ctesperiodicityunit') {
          const ctesperiodicityunit = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicityunit,
            status: 'ERROR',
          };
        }

        ///

        if (field === 'ctesrentalcoef') {
          const ctesrentalcoef = updatedValues;
          const ctesrentalamount = (finAmount * updatedValues) / 100;
          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesrentalamount') {
          const ctesrentalamount = updatedValues;
          const ctesrentalcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesamortizedcoef') {
          const ctesamortizedcoef = updatedValues;
          const ctesoutstandingamount = (finAmount * updatedValues) / 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesoutstandingamount') {
          const ctesoutstandingamount = updatedValues;
          const ctesamortizedcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }
      });
      form?.setFieldsValue({
        elements: {
          FIN: FinElements.map((element: any, index: number) =>
            index === indexElement
              ? {
                  ...element,

                  conElemSteps: newValues,
                  conElemSchedules: [],
                }
              : element
          ),
        },
      });
      // calculateWeightedStepFinancial(index, 'INST');
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );
  const recalculateSteps = useCallback(
    (index: number, field: string, updatedValues: any) => {
      const eleID = isNaN(form?.getFieldValue('selectedElement'))
        ? elementID
        : form?.getFieldValue('selectedElement');
      const indexElement = form
        ?.getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === eleID);
      const FinElements = form?.getFieldValue(['elements', 'FIN']);

      const finAmount =
        form?.getFieldValue([
          'elements',
          'FIN',
          indexElement,
          'cteinvestamount',
        ]) ?? 1;

      var FinElemStep = form?.getFieldValue([
        'elements',
        'FIN',
        indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];
      // eslint-disable-next-line array-callback-return
      const newValues = FinElemStep.map((item, i) => {
        if (i !== index) {
          return item;
        }
        const updatedItem = { ...item, ...{ field: updatedValues } };

        if (field === 'ctesorder') {
          const ctesorder = updatedValues;

          return {
            ...updatedItem,
            ctesorder,
            status: 'ERROR',
          };
        }
        if (field === 'ctesduration') {
          const ctesduration = updatedValues;

          return {
            ...updatedItem,
            ctesduration,
            status: 'ERROR',
          };
        }
        if (field === 'ctesperiodicity') {
          const ctesperiodicity = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicity,
            status: 'ERROR',
          };
        }

        if (field === 'ctesperiodicityunit') {
          const ctesperiodicityunit = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicityunit,
            status: 'ERROR',
          };
        }

        ///

        if (field === 'ctesrentalcoef') {
          const ctesrentalcoef = updatedValues;
          const ctesrentalamount = (finAmount * updatedValues) / 100;

          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesrentalamount') {
          const ctesrentalamount = updatedValues;
          const ctesrentalcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesamortizedcoef') {
          const ctesamortizedcoef = updatedValues;
          const ctesoutstandingamount = (finAmount * updatedValues) / 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesoutstandingamount') {
          const ctesoutstandingamount = updatedValues;
          const ctesamortizedcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }
      });

      form?.setFieldsValue({
        elements: {
          FIN: FinElements.map((element: any, index: number) =>
            index === indexElement
              ? {
                  ...element,
                  conElemSteps: newValues,
                  // conElemSchedules: [],
                }
              : element
          ),
        },
      });
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) => recalculateSteps(index, 'ctesorder', value)}
            />
          );
        },

        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'ctesduration',
        key: 'ctesduration',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesduration', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicity',
        key: 'ctesperiodicity',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="PERIOD"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesperiodicity', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicityunit',
        key: 'ctesperiodicityunit',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="UNIT"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesperiodicityunit', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesrentalcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                value={value}
                currcode={form?.getFieldValue('currcode')}
                onChange={(value) =>
                  recalculateSteps(index, 'ctesrentalamount', value)
                }
              />
              <Button
                size="small"
                icon={
                  <CalculatorTwoTone
                    twoToneColor={record?.status === 'ERROR' ? 'red' : 'green'}
                  />
                }
                onClick={(e) => calculateStepFinancial(index, 'INST')}
              ></Button>
            </Input.Group>
          );
        },

        width: 120,
      },

      {
        comcode: 'ctesamortizedcoef',
        dataIndex: 'ctesamortizedcoef',
        key: 'ctesamortizedcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesamortizedcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesoutstandingamount',
        key: 'ctesoutstandingamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                value={value}
                currcode={form?.getFieldValue('currcode')}
                onChange={(value) =>
                  recalculateSteps(index, 'ctesoutstandingamount', value)
                }
              />
              <Button
                size="small"
                icon={
                  <CalculatorTwoTone
                    twoToneColor={record?.status === 'ERROR' ? 'red' : 'green'}
                  />
                }
                onClick={(e) => calculateStepFinancial(index, 'OUTSTAND')}
              ></Button>
            </Input.Group>
          );
        },

        width: 120,
      },
      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeStep(record.ctesid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    [removeStep, recalculateSteps]
  );
  const columnsWeigthedStep = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesorder', value)
              }
            />
          );
        },

        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'ctesduration',
        key: 'ctesduration',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesduration', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicity',
        key: 'ctesperiodicity',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="PERIOD"
              onSelected={(value) =>
                recalculateWeightedSteps(index, 'ctesperiodicity', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicityunit',
        key: 'ctesperiodicityunit',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="UNIT"
              onSelected={(value) =>
                recalculateWeightedSteps(index, 'ctesperiodicityunit', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesrentalcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                value={value}
                currcode={form?.getFieldValue('currcode')}
                onChange={(value) =>
                  recalculateWeightedSteps(index, 'ctesrentalamount', value)
                }
              />
            </Input.Group>
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesamortizedcoef',
        key: 'ctesamortizedcoef',
        render: (value, record, index) => {
          return <InputRate value={record.ctesamortizedcoef} disabled />;
        },

        width: 120,
      },

      {
        dataIndex: 'ctesoutstandingamount',
        key: 'ctesoutstandingamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                disabled
                currcode={form?.getFieldValue('currcode')}
                value={value}
              />
            </Input.Group>
          );
        },

        width: 120,
      },
      // {
      //   key: 'actions',
      //   comcode: 'actions',
      //   render: (_, record) => (
      //     <Popconfirm
      //       title="Sure to delete?"
      //       onConfirm={() => {
      //         removeWeightedStep(record.ctesid);
      //       }}
      //     >
      //       <DeleteButton onlyIcon />
      //     </Popconfirm>
      //   ),
      //   fixed: 'right',
      //   width: 80,
      // },
    ],
    [recalculateWeightedSteps]
  );
  const columnsSeasonal = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="MONTH"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesorder', value)
              }
            />
          );
        },

        fixed: 'left',
        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <>
              <InputRate
                value={value}
                onChange={(value) =>
                  recalculateSteps(index, 'ctesrentalcoef', value)
                }
              />
              <Button
                size="small"
                icon={
                  <CalculatorTwoTone
                    twoToneColor={record?.status === 'ERROR' ? 'red' : 'green'}
                  />
                }
                onClick={(e) => debouncedCalculateNew('')}
              ></Button>
            </>
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (val) => toCurrency(val, form?.getFieldValue('currcode')),

        width: 120,
      },

      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeStep(record.ctesid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    [removeStep, recalculateSteps]
  );
  const getHelper = (param: string, cteid: any) => {
    if (cteid === 1) {
      return ['elements', 'FIN', 0, 'helpers', param];
    } else {
      if (form?.getFieldValue(['elements', 'FIN'])) {
        const index = form
          ?.getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === cteid);
        return ['elements', 'FIN', index, 'helpers', param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleselectformula = (rateval: number, rateof: string) => {
    let FinElements = form?.getFieldValue(['elements', 'FIN']);
    if (rateof === 'prefin') FinElements[0].prefinrateref = rateval;
    if (rateof === 'cte') {
      FinElements[0].cterateref = rateval;
      FinElements[0].ctenominalrate = rateval + FinElements[0].cteratespread;
    }

    form?.setFieldsValue({
      elements: {
        FIN: FinElements,
      },
    });
  };

  const getPArtAmount = () => {
    const ctepartmethod = form?.getFieldValue(
      getName('ctepartmethod', elementID)
    );

    var ctepartamount = 0;
    if (ctepartmethod === 'PROMO' || ctepartmethod === 'REDUCEFIN') {
      ctepartamount = isNaN(
        form?.getFieldValue(getName('ctepartamount', elementID))
      )
        ? 0
        : form?.getFieldValue(getName('ctepartamount', elementID));
    }
    return ctepartamount;
  };

  const debouncedCalculateNew = debounce((param: string) => {
    const cteid = form?.getFieldValue('selectedElement');
    calculateNew(cteid, param);
  }, 1000);

  const calculateNew = (inCteid: number, param: string) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.findIndex((item: any) => item.cteid === inCteid);

    const finElement = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
    ]) as PropElementResponse;

    if (!finElement || finElement?.ctecalculationtype === null) {
      return;
    }
    var finamount = 0;
    let investamount = finElement.cteinvestamount;
    let firstPayment = 0; //finElement.ctefirstpayment

    var rvcoef = 0;
    var rvamount = 0;

    const listassets = form?.getFieldValue('assets');
    const invest =
      form?.getFieldValue('cttype') === 'LEAD'
        ? form?.getFieldValue(getName('cteinvestamount', inCteid))
        : form?.getFieldValue('cttype') === 'PART'
        ? form?.getFieldValue('ctsyndmgpartamount')
        : form?.getFieldValue(getName('cteinvestamount', inCteid));

    if (param === 'FP') {
      firstPayment = finElement.ctefirstpayment;
    } else {
      firstPayment = !isNaN(finElement.ctefirstpaymentcoef)
        ? (finElement.ctefirstpaymentcoef * invest) / 100
        : finElement.ctefirstpaymentcoef;
    }
    if (param === 'RV') {
      rvamount = finElement.ctervamount;
    } else {
      if (finElement.rvcalculationmode === 'ASSET') {
        let totalAssetRV = 0;
        let assetrvamount = 0;
        const defaultduration = finElement.cteduration;
        listassets.forEach((asset: any) => {
          if (asset.cteid === inCteid) {
            assetrvamount = asset?.listrv?.filter(
              (lrv: any) =>
                defaultduration >= lrv.monthsmin &&
                defaultduration <= lrv.monthsmax &&
                lrv.rvevaluationmode === finElement.rvevaluationmode &&
                lrv.rvtype === 'FIN'
            )[0]?.rvamount;
            assetrvamount = isNaN(assetrvamount) ? 0 : assetrvamount;
            asset.assetrvamount = assetrvamount;
            totalAssetRV = totalAssetRV + assetrvamount;
          }
        });

        rvcoef = (totalAssetRV / invest) * 100;
        rvamount = totalAssetRV;
      } else {
        if (finElement.rvevaluationmode === 'FIXED') {
          rvamount = finElement.ctervamount;
          rvcoef = (rvamount / invest) * 100;
        } else {
          rvcoef = finElement.ctervcoef;
          rvamount = !isNaN(rvcoef)
            ? (rvcoef * invest) / 100
            : finElement.ctervamount;
        }
      }
    }
    // set rvamount for each asset :
    if (finElement.rvcalculationmode !== 'ASSET')
      listassets.forEach((asset: any) => {
        if (asset.cteid === inCteid) {
          asset.assetrvamount = (
            rvamount *
            (asset.assetnetamount / investamount)
          ).toFixed(getRounding(finElement.currcode));
        }
      });

    form?.setFieldsValue({ assets: listassets });

    const rvAmount = rvamount;

    const upfront = finElement.cteupfrontamount;

    let ctepartamount = getPArtAmount();
    const line: any = finElement.conElemSchedules?.find(
      (e: any) => e.ctsduedate === param
    );
    finamount = param
      ? line?.ctsoutstandingamount
      : finElement.ctefinancedamount ?? investamount - upfront - ctepartamount;

    //updating ctefinancedamount
    let elements = form?.getFieldValue('elements');
    let finelements = form?.getFieldValue(['elements', 'FIN']);
    //set rvamount for seasonalcalculation
    finelements[indexElement].ctervamount = rvAmount;
    finelements[indexElement].ctefinancedamount = finamount;
    if (
      finElement.rvcalculationmode === 'ASSET' ||
      finElement.rvevaluationmode === 'FIXED'
    ) {
      finelements[indexElement].helpers.rvmax = rvcoef;
      finelements[indexElement].helpers.rvmin = rvcoef;
    }

    elements = { ...elements, FIN: finelements };

    form?.setFieldsValue({ elements: elements });
    //end updating

    switch (finElement?.ctecalculationtype) {
      case 'SEASON':
        calculateSeasonal(inCteid);
        //OK
        break;
      case 'LINEAR':
        calculateLinearAndWeighted(
          inCteid,
          finElement,
          finamount,
          investamount,
          firstPayment,
          rvAmount
        );
        //OK
        break;
      case 'STEP':
        calculatePaymentSheduleStep(inCteid);
        break;
      case 'STEPWEIGH':
        calculateLinearAndWeighted(
          inCteid,
          finElement,
          finamount,
          investamount,
          0, //firstPayment
          rvAmount
        );
        //OK
        break;
    } // end switch calctype
  };

  const calculateSeasonal = (inCteid: number) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement];

    const FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as any[];

    // calculate FIN

    var finamount = 0;
    // const investamount = finElement.cteinvestamount;
    // const upfront = finElement.cteupfrontamount;

    // var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      // part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = finElement.ctefinancedamount;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      finEngine
        .calculateSeasonalSchedule({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'SEASON',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: 'NONE',
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(form?.getFieldValue('effectDate')),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inDuration: finElement?.cteduration,
            inFirstPayment: 0,
            inResidualValue:
              finElement?.ctervamount === null ? 0 : finElement?.ctervamount,
            inUpFrontAmount:
              finElement?.cteupfrontamount === null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  element.cteid === inCteid
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        conElemSteps: res.elementStep,
                      }
                    : element
                ),
              },
            });

            const conelemsteps = form?.getFieldValue([
              'elements',
              'FIN',
              0,
              'conElemSteps',
            ]);

            //if (conelemsteps!=null ) {

            const newconelem = conelemsteps.map((element: any) => {
              let rent = res.elementStep.filter(
                (e) => Number(e.ctesorder) === Number(element.ctesorder)
              );

              return {
                ...element,
                ctesrentalamount: rent[0].ctesrentalamount,
                status: 'VALID',
              };
            });

            const FIN = form?.getFieldValue(['elements', 'FIN']);
            let elements = form?.getFieldValue('elements');
            FIN[0].conElemSteps = newconelem;
            elements = { ...elements, FIN: FIN };

            form?.setFieldsValue({ elements: elements });

            message.success(res.message);

            calculateServAndComm(res, finElement, finamount, inCteid);
          } // end if success
        });

      /// end calculate FIN
    }
  }; //end calculation of PaymentShedule Seasonal :
  const calculateServAndComm = (
    res: any,
    finElement: PropElementResponse,
    finamount: number,
    inCteid: number
  ) => {
    // calculate FinServices ELEMENTs:
    // calculate Services ELEMENT:

    const finServElements = form
      ?.getFieldValue(['elements', 'FINSERV'])
      .filter((item: any) => item.cteidparent === inCteid);

    let ind = 0;
    for (var finserv of finServElements) {
      calculateFinServiceNew(
        finserv,
        finElement,
        finElement.ctestartdate,
        finElement.ctebilligdate,
        finamount,
        inCteid
      );
      ind = ind + 1;
    }

    // calculate Services ELEMENT:
    const servElements = form
      ?.getFieldValue(['elements', 'SERV'])
      .filter((item: any) => item.cteidparent === inCteid);
    ind = 0;
    for (var serv of servElements) {
      calculateServiceNew(
        serv,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
    // calculate FEES ELEMENT:
    const feesElements = form
      ?.getFieldValue(['elements', 'FEES'])
      .filter((item: any) => item.cteidparent === inCteid);
    ind = 0;
    for (var fees of feesElements) {
      calculateFeesNew(
        fees,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
    // calculate Commissions elements :
    // calculate Services ELEMENT:
    const commElements = form
      ?.getFieldValue(['elements', 'COMM'])
      .filter((item: any) => item.cteidparent === inCteid);

    ind = 0;
    for (var comm of commElements) {
      calculateCommissionNew(
        comm,
        res.inGracePeriodDuration,
        res.inFinancedamount,
        finElement.cteinvestamount,
        finElement.cteinvestamount,
        res.inStartDate,
        res.inDuration,
        res.paymentSchedule,
        inCteid
      );
      ind = ind + 1;
    }
  };

  const calculateFinServiceNew = (
    finserv: any,
    firstFinElement: any,
    ctinitstartdate: any,
    ctbillingdate: any,
    finamount: any,
    inCteid: number
  ) => {
    let finServamount = 0;
    if (finserv.serviceResponse?.servcalculationmethod === 'FIXED') {
      finServamount = finserv.serviceResponse.servfixedamount;
    } else {
      if (finserv.serviceResponse?.servcalculationmethod === 'PERCENT') {
        switch (finserv.serviceResponse.servbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * finserv.serviceResponse.servpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;

          case 'INVEST':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = finserv.cteinvestamount;
      }
    }

    //set finserv=firstFinElement :
    let newfinServ = {
      assetid: firstFinElement.assetid,
      conElemAssets: [],
      conElemSchedules: [] as any,
      conElemSteps: [],
      cteactuarialrate: 0,
      serviceResponse: finserv.serviceResponse,
      pricing: finserv.pricing,
      ctecalculationbasis: finserv.serviceResponse.servbasis,
      ctecalculationtype: 'LINEAR',
      ctecategory: finserv.ctecategory,
      ctedeferredinterest: 0,
      ctedeferredinterestmethod: firstFinElement.ctedeferredinterestmethod,
      ctedeferredinterestnominalrate:
        firstFinElement.ctedeferredinterestnominalrate,
      ctedepositamount: 0,
      ctedepositcoef: 0,
      ctedepositinterest: 0,
      ctedepositinterestmethod: 'NONE',
      ctedepositnominalrate: 0,
      ctedescription: finserv.ctedescription,
      ctedirection: 'IN',
      cteduration: firstFinElement.cteduration,
      cteendamount: 0,
      cteenddate: '',
      ctefinancedamount: finServamount,
      ctefirstpayment: 0,
      ctefirstpaymentcoef: 0,
      ctefirstpaymentdate: '',
      ctefree1: '',
      ctegraceperiodduration: firstFinElement.ctegraceperiodduration,
      ctegraceperiodmethod: firstFinElement.ctegraceperiodmethod,
      cteid: Math.floor(_.random(10000) * 10000),
      cteidparent: inCteid,
      cteinitialamount: finServamount,
      cteinstallmentamount: 0,
      cteinterestmethod: firstFinElement.cteinterestmethod,
      cteinvestamount: finServamount,
      ctenominalrate: firstFinElement.ctenominalrate,
      cteorder: finserv.cteorder,
      ctepartamount: 0,
      ctepartdays: 0,
      ctepartmethod: 'NONE',
      ctepartrate: 0,
      ctepaymentterm: firstFinElement.ctepaymentterm,
      cteperiodicity: firstFinElement.cteperiodicity,
      cteratebasis: firstFinElement.cteratebasis,
      cterateformula: firstFinElement.cterateformula,
      cterateperiodicity: firstFinElement.cterateperiodicity,
      cteratespread: firstFinElement.cteratespread,
      cterateterm: firstFinElement.cterateterm,
      cteratetype: firstFinElement.cteratetype,
      cterentalamount: 0,
      ctervamount: 0,
      ctervcoef: 0,
      ctestartamount: finServamount,
      ctestartdate: firstFinElement.ctestartdate,
      ctestatus: 'INIT',
      ctetype: 'FINSERV',
      cteunit: firstFinElement.cteunit,
      cteupfrontamount: 0,
      ctrid: 0,
      currcode: firstFinElement.currcode,
      last_action: '',
      prefinbasis: '0',
      prefinmethod: '',
      prefinnominalrate: 0,
      prefinperiodicity: '',
      prefinrateformula: '',
      prefinratetype: '',
      priid: finserv.priid,
      taxcode: firstFinElement.taxcode,
      tpid: firstFinElement.tpid,
      tpidparticipation: '',
    };

    finEngine
      .calculate({
        finReq: {
          inBillingDate: firstFinElement.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType:firstFinElement?.ctecalculationtype,
          inCountingbasis: firstFinElement?.cteratebasis,
          inDeferredMethod: firstFinElement?.ctedeferredinterestmethod,
          inDeferredRate: firstFinElement?.ctedeferredinterestnominalrate,
          inDepositAmount: 0,

          inDepositMethod: 'NONE',
          inDepositRate: 0,
          inDuration:
            firstFinElement?.cteduration == null
              ? 1
              : firstFinElement?.cteduration,
          inFinancedAmount: finServamount,
          inFirstInstallmentDate: '', //dateTimeToDate(firstFinElement?.ctestartdate),
          inFirstPayment: 0,
          inGracePeriodDuration:
            firstFinElement?.ctegraceperiodduration == null
              ? 0
              : firstFinElement?.ctegraceperiodduration,
          inGracePeriodMethod: firstFinElement?.ctegraceperiodmethod,
          inInstallmentAmount: 0,
          inInterestMethod: firstFinElement?.cteinterestmethod,
          inPartAmount: 0,
          inPartMethod: 'NONE',
          inPartNbDays: 0,
          inPartRate: 0,
          inPeriodicity: firstFinElement?.cteperiodicity,
          inPeriodicityUnit: firstFinElement?.cteunit,
          inRatePeriodicity: firstFinElement?.cterateperiodicity,
          inRateType: firstFinElement?.cteratetype,
          inRateValue:
            firstFinElement?.ctenominalrate == null
              ? 0
              : firstFinElement?.ctenominalrate,
          inResidualValue: 0,
          inRoundingAmount: getRounding(firstFinElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(firstFinElement.ctestartdate),
          inTaxcode: firstFinElement?.taxcode,
          inTaxrate: firstFinElement?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: firstFinElement?.ctepaymentterm,
          inUpFrontAmount: 0,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('FinService ' + res.message);

          newfinServ.conElemSchedules = res.paymentSchedule;
          newfinServ.cteactuarialrate = res.effectiverate;
          newfinServ.ctedeferredinterest = res.deferredInterest;
          newfinServ.ctedepositinterest = res.depositInterest;
          newfinServ.cteduration = res.duration;
          newfinServ.ctefinancedamount = res.financedamount;
          newfinServ.cteinstallmentamount = res.installmentamount;
          newfinServ.cterentalamount = res.installmentamount;
          const finServElements =
            form?.getFieldValue(['elements', 'FINSERV']) || [];

          form?.setFieldsValue({
            elements: {
              FINSERV: finServElements.map((element: any, index: any) => {
                return element.cteid === finserv.cteid ? newfinServ : element;
              }),
            },
          });
        }
      });
  };

  const calculateServiceNew = (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.serviceResponse.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.serviceResponse.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree: servElement.serviceResponse.servdurationdefault,

          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          const servElements = form?.getFieldValue(['elements', 'SERV']) || [];

          form?.setFieldsValue({
            elements: {
              SERV: servElements.map((element: any, index: any) =>
                element.cteid === servElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,

                      cteduration: res.duration,

                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
          // create new function to create new service out
          // add Servout
          // if supplier or there's out in response of service (serviceResponse)..
          // handlepricing and manual add of service=> pricing to element or new function...
        }
      });
  };

  const calculateFeesNew = (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.serviceResponse.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.serviceResponse.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree: servElement.serviceResponse.servdurationdefault,

          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Fees - ' + res.message);

          const feesElements = form?.getFieldValue(['elements', 'FEES']) || [];

          form?.setFieldsValue({
            elements: {
              FEES: feesElements.map((element: any, index: any) =>
                element.cteid === servElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,

                      cteduration: res.duration,

                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
        }
      });
  };

  const calculateCommissionNew = (
    commElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    let finServamount = 0;

    if (commElement.commissionResponse?.commcalculationmethod === 'FIXED') {
      finServamount = commElement.commissionResponse.commfixedamount;
    } else {
      if (commElement.commissionResponse?.commcalculationmethod === 'PERCENT') {
        switch (commElement.commissionResponse.commbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * commElement.commissionResponse.commpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;

          case 'INVEST':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = commElement.cteinstallmentamount;
      }
    }
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finServamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: commElement.ctecategory,
          inRoudingAmount: getRounding(commElement.currcode),
          inServcalculationmethod:
            commElement.commissionResponse.commcalculationmethod,
          inServfixedamount:
            commElement.commissionResponse.commfixedamount === null
              ? 0
              : commElement.commissionResponse.commfixedamount,
          inServiceduration: commElement.commissionResponse.commduration,
          inServpercentage:
            commElement.commissionResponse.commpercentage === null
              ? 0
              : commElement.commissionResponse.commpercentage,
          inTaxcode: commElement?.taxcode,
          inTaxrate: commElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: commElement.commissionResponse.commperiodicity,
          inServDurationFree:
            commElement.commissionResponse.commdurationdefault,

          inStartDate: startDate,
          inServbasis: commElement.commissionResponse.commbasis,

          inCalculatedamountbasis: 'ANNUAL',

          inMarginoncalcultedamount: 0,
          inAdditionalcostaftermargin: 0,

          servStep: [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Commission - ' + res.message);
          const commElements = form?.getFieldValue(['elements', 'COMM']) || [];

          form?.setFieldsValue({
            elements: {
              COMM: commElements.map((element: any, index: any) =>
                element.cteid === commElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteduration: res.duration,
                      cteinstallmentamount: res.inInstallmentAmount,
                      cterentalamount: res.inInstallmentAmount,
                    }
                  : element
              ),
            },
          });
        }
      });
  };

  const calculateLinearAndWeighted = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number,
    investamount: number,
    firstPayment: number,
    rvAmount: number
  ) => {
    finEngine
      .calculate({
        finReq: {
          inBillingDate: finElement?.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType:finElement?.ctecalculationtype,
          inCountingbasis: finElement?.cteratebasis,
          inDeferredMethod: 'NONE',
          inDeferredRate: finElement?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElement?.ctedepositamount == null
              ? 0
              : finElement?.ctedepositamount,
          inDepositMethod: finElement?.ctedepositinterestmethod,
          inDepositRate:
            finElement?.ctedepositinterestmethod === 'NONE'
              ? 0
              : finElement?.ctedepositnominalrate == null
              ? 0
              : finElement?.ctedepositnominalrate,
          inDuration: form?.getFieldValue(getName('cteduration', elementID))
            ? form?.getFieldValue(getName('cteduration', elementID))
            : finElement?.cteduration == null
            ? 1
            : finElement?.cteduration,
          inFinancedAmount: finamount,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: 0,
          inGracePeriodDuration:
            finElement?.ctegraceperiodduration == null
              ? 0
              : finElement?.ctegraceperiodduration,
          inGracePeriodMethod: finElement?.ctegraceperiodmethod,
          inInstallmentAmount: finElement?.cteinstallmentamount,
          inInterestMethod: finElement?.cteinterestmethod,
          inPartAmount:
            finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
          inPartMethod: finElement?.ctepartmethod
            ? finElement?.ctepartmethod
            : 'NONE',
          inPartNbDays:
            finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
          inPartRate:
            finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
          inPeriodicity: finElement?.cteperiodicity,
          inPeriodicityUnit: finElement?.cteunit,
          inRatePeriodicity: Number(finElement?.cterateperiodicity),
          inRateType: finElement?.cteratetype,
          inRateValue:
            finElement?.ctenominalrate == null ? 0 : finElement?.ctenominalrate,
          inResidualValue: rvAmount == null ? 0 : rvAmount,
          inRoundingAmount: getRounding(finElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inTaxcode: finElement?.taxcode,
          inTaxrate: finElement?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: finElement?.ctepaymentterm,
          inUpFrontAmount:
            finElement?.cteupfrontamount == null
              ? 0
              : finElement?.cteupfrontamount,
        },
      })
      .then((res) => {
        if (res.success) {
          // calculate RVI :

          // calculate Weighted Steps :
          if (finElement?.ctecalculationtype === 'STEPWEIGH') {
            // add Steps based on Config :
            //finElement.conElemSteps = [];

            //finElement.conElemSteps = calculateREC(
            // eslint-disable-next-line no-unused-vars
            let steps = calculateREC(
              finamount,
              dateToString(finElement?.ctestartdate),
              0,
              finElement.conElemSteps[0],
              finElement,
              res.installmentamount,
              []
            );

            // end .then

            // end loop on steps
          } // end if STEPWEIGH
          // end if STEPWEIGH

          message.success(res.message);

          const FinElements = form?.getFieldValue(['elements', 'FIN']) || [];

          form?.setFieldsValue({
            elements: {
              FIN: FinElements.map((element: any, index: number) =>
                element.cteid === inCteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteactuarialrate: res.effectiverate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedepositinterest: res.depositInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      conElemSteps: finElement.conElemSteps,
                      cteduration: res.duration,
                      ctefinancedamount: res.financedamount,
                      ctefirstpayment:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : res.inFirstPayment,
                      ctefirstpaymentcoef:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : (res.inFirstPayment / investamount) * 100,
                      cteinstallmentamount: res.installmentamount,
                      cterentalamount:
                        res.installmentamount - res.depositInterest,
                      // ctervamount: res.residualvalue,
                      ctervcoef: (res.residualvalue / investamount) * 100,
                    }
                  : element
              ),
            },
          });

          calculateIRV(
            inCteid,
            investamount,
            finamount,
            finElement.ctestartdate,
            finElement.ctebilligdate,
            finElement.ctepaymentterm,
            res.paymentSchedule
          );

          calculateServAndComm(res, finElement, finamount, inCteid);
        }
      }); // end then
  };

  const calculateREC = (
    stepStartamount: any,
    stepStartdate: any,
    i: number,
    currentStep: any,
    finElement: any,
    installmentamount: any,
    finElementconElemStep: any
  ) => {
    if (i === finElement.conElemSteps.length) {
      calculatePaymentSheduleWeightedStep('STEPWEIGH', finElementconElemStep);
      return finElementconElemStep;
    } else {
      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod:
              finElement.conElemSteps.length - 1 === i ? 'INST' : 'OUTSTAND',
              inCalculationType:finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: currentStep.ctesduration,
            inFinancedAmount: stepStartamount ?? 0,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount:
              finElement.conElemSteps.length - 1 === i
                ? 0
                : (currentStep.ctesrentalcoef * installmentamount) / 100,
            inInterestMethod: i === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: currentStep.ctesperiodicity,
            inPeriodicityUnit: currentStep.ctesperiodicityunit ?? 'M',
            inRatePeriodicity: Number(finElement?.cterateperiodicity),
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue:
              finElement.conElemSteps.length - 1 === i
                ? finElement.ctervamount
                : 0, //e.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: stepStartdate, //dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((resStep) => {
          if (resStep.success) {
            // update Step :

            finElementconElemStep.push({
              cteid: finElement.cteid,
              ctesamortizedcoef: (
                (resStep.residualvalue / finElement.cteinvestamount) *
                100
              ).toFixed(3),
              ctesduration: currentStep.ctesduration,
              ctesid: currentStep.ctesid,
              ctesorder: currentStep.ctesorder,
              ctesoutstandingamount: resStep.residualvalue,
              ctesperiodicity: currentStep.ctesperiodicity,
              ctesperiodicityunit: currentStep.ctesperiodicityunit ?? 'M',
              ctesperiodicityunitlabel: '',
              ctesrentalamount: resStep.installmentamount, //*e.ctesrentalcoef/100,
              ctesrentalcoef: (
                (resStep.installmentamount / installmentamount) *
                100
              ).toFixed(3),
              ctrid: finElement.ctrid,
              status: 'VALID',
            });

            stepStartamount = resStep.residualvalue;
            stepStartdate = resStep.paymentSchedule.find(
              (e) => e.ctstype === 'RV'
            )?.ctsenddate;

            calculateREC(
              stepStartamount,
              stepStartdate,
              i + 1,
              finElement.conElemSteps[i + 1],
              finElement,
              installmentamount,
              finElementconElemStep
            );
          } // end success calculation
        });

      //return finElementconElemStep;
    }
  };

  const calculateIRV = async (
    inCteid: number,
    investAmount: any,
    finAmount: any,
    startDate: any,
    inBillingDate: string,
    inTerm: string,
    finSchedule: any
  ) => {
    const listassets = form?.getFieldValue('assets');
    listassets.forEach(async (asset: any) => {
      if (
        asset.cteid === inCteid &&
        asset.listrv?.find((e: any) => e.rvtype === 'IRV')
      ) {
        await finEngine
          .calculateIRVSchedule({
            irvReq: {
              finSchedule: finSchedule,
              inInvestAmount: investAmount,
              inFinAmount: finAmount,
              inAssetAmount: asset.assetnetamount,
              inStartDate: startDate,
              inBillingDate: inBillingDate,
              inTerm: inTerm,
              inRoundingAmount: 2,
              assetRvCalcParams: asset.listrv.filter(
                (e: any) => e.rvtype === 'IRV'
              ),
            },
          })
          .then((res2: any) => {
            if (res2.success) {
              message.success('IRV - ' + res2.message);
              form?.setFieldsValue({
                assets: listassets.map((ele: any) => {
                  if (asset.assetid === ele.assetid)
                    return { ...ele, irvSchedule: res2.irvSchedule };
                  else return ele;
                }),
              });
            }
          });
      }
    });
  };

  const calculatePaymentSheduleWeightedStep = (
    method: string,
    FinElemStep: any
  ) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);

    const finElement = FinElements[indexElement];

    /*const FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as any[];
*/
    // calculate FIN

    var finamount = 0;
    const investamount = finElement.cteinvestamount;
    // eslint-disable-next-line no-unused-vars
    const firstPayment = finElement.ctefirstpayment;
    // eslint-disable-next-line no-unused-vars
    const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = investamount - upfront - part;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method ?? 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode:"",
              inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);
            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              // eslint-disable-next-line no-unused-vars
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              // eslint-disable-next-line no-unused-vars
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        conElemSteps: res.elementStep,
                      }
                    : element
                ),
              },
            });
          } else {
            message.error(res.message);
          }
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const calculatePaymentSheduleStep = (inCteid: number) => {
    const indexElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form?.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement !== -1 ? indexElement : 0];

    let FinElemStep = form?.getFieldValue([
      'elements',
      'FIN',
      indexElement !== -1 ? indexElement : 0,
      'conElemSteps',
    ]) as any[];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // eslint-disable-next-line no-unused-vars
    const firstPayment = finElement.ctefirstpayment;
    // eslint-disable-next-line no-unused-vars
    const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    finamount = investamount - upfront - part;

    if (
      FinElemStep === null ||
      FinElemStep === undefined ||
      isEmpty(FinElemStep)
    ) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: PropElemStepRequest) => {
        s.ctesoutstandingamount = (investamount * s.ctesamortizedcoef) / 100;
      });

      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode:"",
              inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          if (res.success) {
            message.success(res.message);

            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }
            setAssetRvAmount(_.last(res.elementStep)?.ctesoutstandingamount);

            form?.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        ctedeferredinterestnominalrate: res.inDeferredRate,
                        ctedeferredinterest: res.deferredInterest,
                        ctedepositnominalrate: res.inDepositRate,
                        ctedepositinterest: res.depositInterest,
                        ctervamount: rvamount,
                        ctervcoef: rvcoef,
                        ctefirstpayment: 0,
                        ctefirstpaymentcoef: 0,
                        conElemSteps: res.elementStep.map((step) => {
                          return {
                            ...step,
                            ctesid: Math.floor(_.random(10000) * 10000000), //theres no ctesid received
                            ctesamortizedcoef: step.ctesamortizedcoef,
                          };
                        }),
                      }
                    : element
                ),
              },
            });

            calculateServAndComm(res, finElement, finamount, inCteid);
          } else {
            message.error(res.message);
          }
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: data?.conElements[0].conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: data?.conElements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: data?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: data?.conElements[0]?.cteduration ?? 0,
          inInvestAmount: data?.conElements[0]?.cteinvestamount ?? 0,
          inAssetAmount: data?.assets[0]?.assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesFormula: pricing?.priid,
          });
        }
      });
  };

  const setAssetRvAmount = (rvamount: any) => {
    const cteid = form?.getFieldValue('selectedElement');
    let assets = form
      ?.getFieldValue('assets')
      .filter((asset: any) => asset.cteid === cteid);
    const FinElement = form
      ?.getFieldValue(['elements', 'FIN'])
      .find((ele: any) => ele.cteid === cteid);
    assets = assets.map((asset: any) => {
      return {
        ...asset,
        assetrvamount:
          (Number(asset.assetnetamount) / FinElement.cteinvestamount) *
          rvamount,
      };
    });
    form?.setFieldsValue({
      assets: assets,
    });
  };

  const handleSelectedElement = (cteid: number) => {
    form?.setFieldsValue({
      selectedElement: cteid,
      effectDate: '',
    });

    setElementID(cteid);

    debouncedCalculateNew('');
  };

  useEffect(() => {
    if (data) {
      const {
        FIN = [],
        SERV = [],
        FEES = [],
        COMM = [],
        FINSERV = [],
      } = groupBy(
        conElementToElement(data!.conElements as any, data!.offer).map(
          (ele) => {
            return { ...ele, flagStop: false };
          }
        ) || [],
        'ctetype'
      );
      form?.setFieldsValue({
        flagmasterfacility: data!.flagmasterfacility,
        flagasset: data!.flagasset,
        flagrealestate: data!.flagrealestate,
        mfprcode: data!.mfprcode,
        selectedElement: data!.conElements!.find(
          (e: any) => e.ctetype === 'FIN'
        )?.cteid,
        assets: data!.assets,
        brid: data!.brid,
        borrower: {
          tpid: data!.tpidcoborrower,
        },
        broker: {
          tpid: data!.tpidbroker,
          tpname: data!.brokername,
          tpreference: data!.brokerreference,
        },
        channelcode: '',
        client: {
          tpid: data!.tpidclient,
          tpname: data!.clientname,
          tpreference: data!.clientreference,
        },
        ctacceptancedate: data!.ctacceptancedate,
        ctactivationdate: data!.ctactivationdate,
        ctbankname: data!.ctbankname,
        ctbic: data!.ctbic,
        ctbillingdate: data!.ctbillingdate,
        ctcbdate: data!.ctcbdate,
        ctcbkey: data!.ctcbkey,
        ctcbname: data!.ctcbname,
        ctcbnum: data!.ctcbnum,
        ctcbtype: data!.ctcbtype,
        ctdeliverydate: data!.ctdeliverydate,
        ctdescription: data!.ctdescription,
        ctenddate: data!.ctenddate,
        ctfinancedamount: data!.ctfinancedamount,
        ctflagreminder: data!.ctflagreminder,
        ctiban: data!.ctiban,
        ctidautorization: data!.ctidautorization,
        ctinitenddate: data!.ctinitenddate,
        ctinitstartdate: moment(
          data!.ctinitstartdate ?? new Date(),
          'YYYY-MM-DD'
        ),
        ctinvoicingmode: data!.ctinvoicingmode,
        ctpartialpayoffformula: data!.ctpartialpayoffformula,
        ctlateinterestformula: data!.ctlateinterestformula,
        cttotalpayoffformula: data!.cttotalpayoffformula,
        ctorderdate: data!.ctorderdate,
        ctpaymentdelay: data!.ctpaymentdelay,
        ctpaymentmode: data!.ctpaymentmode,
        propreference: data!.propreference,
        ctreference: data!.ctreference,
        currcode: data!.currcode,
        ctstatuslabel: data!.ctstatuslabel + ' (' + data!.ctstatusdate + ')',
        ctrequestdate: moment(data!.ctrequestdate ?? new Date(), 'YYYY-MM-DD'),
        cttype: data!.cttype,
        ctfclevel: data!.ctfclevel,
        description: data!.ctdescription,
        elements: {
          COMM,
          FEES,
          FIN,
          FINSERV,
          SERV,
        },
        prcode: data!.prcode,
        offerid: data!.offerid,
        pricing: { ofrid: data!.priid, ofrlabel: data!.prilabel },
        effectDate: form?.getFieldValue('effectDate') ?? '',
        olddata: conElementToElement(data!.conElements as any, data!.offer),
      });

      updateState({
        oldData: conElementToElement(data!.conElements as any, data!.offer),
      });
    }
  }, [data, form, objectid]);

  return (
    <DF.Provider pagcode="tabcontractrescheduling">
      <Row>
        <Col span={24}>
          <Spin spinning={state.isLoading || isLoading} delay={500}>
            <Row gutter={[8, 8]}>
              <FormInput
                col
                xs={4}
                name="effectDate"
                rules={[{ required: true }]}
              >
                <Select
                  defaultValue=""
                  size="small"
                  style={{ width: '100%' }}
                  onChange={handleeffectDatechange}
                >
                  {optionDates}
                </Select>
              </FormInput>
              <FormInput col xs={5} name="mode" rules={[{ required: true }]}>
                <Radio.Group
                  options={optionsMode}
                  defaultValue="SIMUL"
                  optionType="button"
                  disabled={state.isModSelected}
                />
              </FormInput>
              <FormInput col xs={4} name="modid">
                <Select
                  size="small"
                  allowClear
                  style={{ width: '100%' }}
                  onChange={(e: number) => handleFinModSelect(e)}
                >
                  {optionModListValid}
                </Select>
              </FormInput>
              <FormInput
                col
                xs={6}
                name="feesFormula"
                rules={[{ required: true }]}
              >
                <PricingListFilteredSelect
                  //disabled={!getFieldValue('offerid')}
                  allowClear
                  disabled={state.isModSelected}
                  params={{
                    offerid: data?.offerid ?? 0,
                    ctetype: 'MODFEES', // Modifictaion fees
                    prcode: data?.prcode ?? '',
                    entity: '',
                    entityid: 0,
                    tpid: data?.tpidclient ?? 0,
                  }}
                  onChange={(e) => calculateFees(e)}
                />
              </FormInput>
              <FormInput col xs={5} name="feesAmount">
                <InputMoney defaultValue={0} disabled={state.isModSelected} />
              </FormInput>
            </Row>
            <Form.Item shouldUpdate={shouldUpdateCompare('elements')} noStyle>
              {({ getFieldValue }) => {
                const allelements = getFieldValue('elements') || [];
                const elements = unGroup(allelements);
                const allFIN = elements.filter(
                  (ele: any) => ele.ctetype === 'FIN'
                );
                const data = allFIN.map((ele: any) => {
                  const linkedServices = elements.filter(
                    (serv: any) => serv.cteidparent === ele.cteid
                  );

                  return {
                    ...ele,
                    children: linkedServices,
                  };
                });
                return (
                  <ElementsFinTable
                    form={form}
                    display
                    elements={[...data]}
                    oldElements={state.oldData}
                    onDeleteElement={() => null}
                    onSelect={handleSelectedElement}
                    offerid={form?.getFieldValue('offerid')}
                    prcode={
                      form?.getFieldValue('flagmasterfacility')
                        ? getFieldValue('mfprcode')
                        : getFieldValue('prcode')
                        ? getFieldValue('prcode')
                        : ''
                    }
                  />
                );
              }}
            </Form.Item>

            <Divider orientation="left">New Conditions</Divider>
            <Card bordered>
              <Row gutter={[8, 8]}>
                <Form.Item shouldUpdate={() => true} noStyle>
                  <FormInput
                    col
                    xs={7}
                    name={getName('ctecalculationtype', elementID)}
                  >
                    <ParListSelect parcode="CALMETRES" />
                  </FormInput>
                </Form.Item>

                <Form.Item shouldUpdate={() => true} noStyle>
                  {({ getFieldValue }) => (
                    <FormInput
                      col
                      xs={12}
                      comcode="ctenominalrate"
                      name={getName('ctenominalrate', elementID)}
                    >
                      <SliderWithInput
                        max={getFieldValue(getHelper('ratemax', elementID))}
                        min={getFieldValue(getHelper('ratemin', elementID))}
                        step={0.001}
                        precision={5}
                        widthInput={5}
                        onChange={() => debouncedCalculateNew('')}
                      />
                    </FormInput>
                  )}
                </Form.Item>
              </Row>
            </Card>

            <Divider orientation="left">Steps</Divider>

            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const calcmethod = getFieldValue(
                  getName('ctecalculationtype', elementID)
                );
                const steps =
                  getFieldValue(getName('conElemSteps', elementID)) ?? [];

                if (calcmethod === 'LINEAR' || calcmethod === 'FIXEDAMORT') {
                  return (
                    <Card
                      bordered
                      title={<Title level={4} comcode="LinearPayment"></Title>}
                    >
                      <Row gutter={[8, 8]}>
                        <Form.Item shouldUpdate={() => true} noStyle>
                          {({ getFieldValue }) => {
                            return (
                              <FormInput
                                col
                                xs={6}
                                name={getName('cteperiodicity', elementID)}
                              >
                                <ParListSelect
                                  parcode="PERIOD"
                                  onSelected={() => debouncedCalculateNew('')}
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                        <Form.Item shouldUpdate={() => true} noStyle>
                          <FormInput
                            col
                            xs={6}
                            name={getName('cteunit', elementID)}
                          >
                            <ParListSelect
                              parcode="UNIT"
                              onSelected={() => debouncedCalculateNew('')}
                            />
                          </FormInput>
                        </Form.Item>
                        {calcmethod === 'LINEAR' && (
                          <Form.Item shouldUpdate={() => true} noStyle>
                            {({ getFieldValue }) => (
                              <FormInput
                                col
                                xs={12}
                                comcode="cteduration"
                                name={getName('cteduration', elementID)}
                              >
                                <SliderWithInput
                                  max={getFieldValue(
                                    getHelper('durationmax', elementID)
                                  )}
                                  min={getFieldValue(
                                    getHelper('durationmin', elementID)
                                  )}
                                  precision={0}
                                  onChange={() => debouncedCalculateNew('')}
                                />
                              </FormInput>
                            )}
                          </Form.Item>
                        )}
                      </Row>
                      <Row gutter={[8, 0]}>
                        <Form.Item shouldUpdate={() => true} noStyle>
                          {({ getFieldValue }) => {
                            const indexElement = form
                              ?.getFieldValue(['elements', 'FIN'])
                              ?.findIndex(
                                (item: any) =>
                                  item.cteid ===
                                  getFieldValue('selectedElement')
                              );

                            const finElement = form?.getFieldValue([
                              'elements',
                              'FIN',
                              indexElement,
                            ]);
                            return (
                              <FormInput
                                col
                                xs={12}
                                comcode="ctervamount"
                                name={getName('ctervamount', elementID)}
                              >
                                <SliderWithInputAndPercentage
                                  currcode={getFieldValue('currcode')}
                                  disabled={
                                    finElement?.rvcalculationmode === 'ASSET'
                                  }
                                  max={getFieldValue(
                                    getHelper('rvmax', elementID)
                                  )}
                                  min={getFieldValue(
                                    getHelper('rvmin', elementID)
                                  )}
                                  basis={getFieldValue(
                                    getName('cteinvestamount', elementID)
                                  )}
                                  step={1}
                                  precisionAmount={2}
                                  precisionCoef={5}
                                  onChange={() => debouncedCalculateNew('RV')}
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>

                        <FormInput
                          style={{ color: 'blue' }}
                          col
                          xs={6}
                          comcode="cteinstallmentamount"
                          name={getName('cteinstallmentamount', elementID)}
                        >
                          <Value
                            formatter={(value) =>
                              toCurrency(value, getFieldValue('currcode'))
                            }
                          ></Value>
                        </FormInput>
                        <FormInput
                          style={{ color: 'green' }}
                          col
                          xs={6}
                          comcode="ctedepositinterest"
                          name={getName('ctedepositinterest', elementID)}
                        >
                          <Value
                            formatter={(value) =>
                              toCurrency(value, getFieldValue('currcode'))
                            }
                          ></Value>
                        </FormInput>
                        <FormInput
                          style={{ color: 'red' }}
                          col
                          xs={6}
                          name={getName('cterentalamount', elementID)}
                          comcode="cterentalamount"
                        >
                          <Value
                            formatter={(value) =>
                              toCurrency(value, getFieldValue('currcode'))
                            }
                          ></Value>
                        </FormInput>
                      </Row>
                    </Card>
                  );
                } else {
                  if (calcmethod === 'STEP') {
                    return (
                      <Card
                        bordered
                        title={<Title level={4} comcode="StepPayment"></Title>}
                      >
                        <Row>
                          <Col span={4} style={{ textAlign: 'left' }}>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FinancialScheduleModal
                                  comcode="finSchedule"
                                  finElement={getFieldValue(
                                    getName('conElemSchedules', elementID)
                                  )}
                                  controller={
                                    <ScheduleButton
                                      size="large"
                                      onClickCapture={(e) =>
                                        calculatePaymentSheduleStep(
                                          form?.getFieldValue('selectedElement')
                                        )
                                      }
                                      comcode="finSchedule"
                                      twoToneColor={
                                        form?.getFieldValue(
                                          getName('elementstatus', elementID)
                                        ) === 'ERROR'
                                          ? 'red'
                                          : 'blue'
                                      }
                                    ></ScheduleButton>
                                  }
                                />
                              )}
                            </Form.Item>
                          </Col>

                          <Col span={4}>
                            <NewButtonSmall
                              type="primary"
                              onClick={addStep}
                              comcode="add"
                            />
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]}>
                          <DataGrid
                            rowKey="ctesid"
                            dataSource={[...steps]}
                            columns={columns}
                          />
                        </Row>
                      </Card>
                    );
                  } else {
                    if (calcmethod === 'STEPWEIGH') {
                      return (
                        <Card
                          bordered
                          title={
                            <Title
                              level={4}
                              comcode="WeightedStepPayment"
                            ></Title>
                          }
                        >
                          <Row>
                            <Col span={11}>
                              <Row gutter={[8, 0]}>
                                <FormInput
                                  style={{ color: 'blue' }}
                                  col
                                  xs={6}
                                  comcode="cteinstallmentamount"
                                  name={getName(
                                    'cteinstallmentamount',
                                    elementID
                                  )}
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                                <FormInput
                                  style={{ color: 'green' }}
                                  col
                                  xs={6}
                                  comcode="ctedepositinterest"
                                  name={getName(
                                    'ctedepositinterest',
                                    elementID
                                  )}
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                                <FormInput
                                  style={{ color: 'red' }}
                                  col
                                  xs={6}
                                  name={getName('cterentalamount', elementID)}
                                  comcode="cterentalamount"
                                >
                                  <Value
                                    formatter={(value) =>
                                      toCurrency(
                                        value,
                                        getFieldValue('currcode')
                                      )
                                    }
                                  ></Value>
                                </FormInput>
                              </Row>
                            </Col>
                            <Col span={11}>
                              <Form.Item shouldUpdate={() => true} noStyle>
                                {({ getFieldValue }) => {
                                  const indexElement = form
                                    ?.getFieldValue(['elements', 'FIN'])
                                    ?.findIndex(
                                      (item: any) =>
                                        item.cteid ===
                                        getFieldValue('selectedElement')
                                    );

                                  const finElement = form?.getFieldValue([
                                    'elements',
                                    'FIN',
                                    indexElement,
                                  ]);
                                  return (
                                    <FormInput
                                      col
                                      xs={22}
                                      comcode="ctervamount"
                                      name={getName('ctervamount', elementID)}
                                    >
                                      <SliderWithInputAndPercentage
                                        currcode={getFieldValue('currcode')}
                                        disabled={
                                          finElement.rvcalculationmode ===
                                          'ASSET'
                                        }
                                        max={getFieldValue(
                                          getHelper('rvmax', elementID)
                                        )}
                                        min={getFieldValue(
                                          getHelper('rvmin', elementID)
                                        )}
                                        basis={getFieldValue(
                                          getName('cteinvestamount', elementID)
                                        )}
                                        step={1}
                                        precisionAmount={2}
                                        precisionCoef={5}
                                        onChange={() =>
                                          debouncedCalculateNew('')
                                        }
                                      />
                                    </FormInput>
                                  );
                                }}
                              </Form.Item>
                            </Col>

                            <Col span={2}>
                              <NewButtonSmall
                                type="primary"
                                onClick={addWeightedStep}
                                comcode="add"
                              />

                              <br />
                              <br />
                              <Form.Item shouldUpdate={() => true} noStyle>
                                {({ getFieldValue }) => (
                                  <FinancialScheduleModal
                                    finElement={getFieldValue(
                                      getName('conElemSchedules', elementID)
                                    )}
                                    comcode="finSchedule"
                                    controller={
                                      <ScheduleButton
                                        onClickCapture={(e) =>
                                          calculatePaymentSheduleWeightedStep(
                                            getFieldValue(
                                              getName(
                                                'ctecalculationtype',
                                                elementID
                                              )
                                            ),
                                            getFieldValue(
                                              getName('conElemSteps', elementID)
                                            )
                                          )
                                        }
                                        size="large"
                                        comcode="finSchedule"
                                        twoToneColor="blue"
                                      ></ScheduleButton>
                                    }
                                  />
                                )}
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row gutter={[8, 8]}>
                            <DataGrid
                              rowKey="ctesid"
                              dataSource={[...steps]}
                              columns={columnsWeigthedStep}
                            />
                          </Row>
                        </Card>
                      );
                    }
                    return (
                      <Card
                        bordered
                        title={
                          <Title level={4} comcode="SeasonalPayment"></Title>
                        }
                      >
                        <Row>
                          <Col span={12}>
                            <Form.Item shouldUpdate={() => true} noStyle>
                              {({ getFieldValue }) => (
                                <FormInput
                                  col
                                  xs={15}
                                  comcode="ctervamount"
                                  name={getName('ctervamount', elementID)}
                                >
                                  <SliderWithInputAndPercentage
                                    currcode={getFieldValue('currcode')}
                                    max={getFieldValue(
                                      getHelper('rvmax', elementID)
                                    )}
                                    min={getFieldValue(
                                      getHelper('rvmin', elementID)
                                    )}
                                    basis={getFieldValue(
                                      getName('cteinvestamount', elementID)
                                    )}
                                    step={1}
                                    precisionAmount={2}
                                    precisionCoef={5}
                                    onChange={() => debouncedCalculateNew('')}
                                  />
                                </FormInput>
                              )}
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Row>
                              <Col span={6}>
                                <Button
                                  size="small"
                                  icon={
                                    <CalculatorTwoTone
                                      twoToneColor={
                                        form?.getFieldValue(
                                          getName('elementstatus', elementID)
                                        ) === 'ERROR'
                                          ? 'red'
                                          : 'green'
                                      }
                                    />
                                  }
                                  onClick={(e) =>
                                    calculateSeasonal(
                                      form?.getFieldValue('selectedElement')
                                    )
                                  }
                                />
                              </Col>
                              <Col span={12} style={{ textAlign: 'left' }}>
                                <Form.Item shouldUpdate={() => true} noStyle>
                                  {({ getFieldValue }) => (
                                    <FinancialScheduleModal
                                      finElement={getFieldValue(
                                        getName('conElemSchedules', elementID)
                                      )}
                                      comcode="finSchedule"
                                      controller={
                                        <ScheduleButton
                                          size="large"
                                          comcode="finSchedule"
                                          twoToneColor="blue"
                                        ></ScheduleButton>
                                      }
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={6}>
                                <NewButtonSmall
                                  type="primary"
                                  onClick={addStep}
                                  comcode="add"
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]}>
                          <DataGrid
                            rowKey="ctesid"
                            dataSource={[...steps]}
                            columns={columnsSeasonal}
                          />
                        </Row>
                      </Card>
                    );
                  }
                }
              }}
            </Form.Item>
          </Spin>
        </Col>
      </Row>
      <br />
      <Row gutter={[8, 8]}>
        <FormInput col xs={20} name="comment" rules={[{ required: true }]}>
          <TextArea rows={4} />
        </FormInput>
      </Row>
      <Form.Item name="olddata" noStyle></Form.Item>
      <Form.Item name="elements" noStyle></Form.Item>
    </DF.Provider>
  );
};
export default TabCTRescheduling;
